import { useEffect, useMemo, useRef } from 'react';
import { debounce } from 'lodash-es';

export const useDebounce = <A extends any[]>(
  callback: (...args: A) => void,
  delay = 300,
) => {
  const callbackRef = useRef(callback);
  callbackRef.current = callback;

  const debouncedResults = useMemo(() => {
    return debounce((...args: A) => {
      callbackRef.current(...args);
    }, delay);
  }, [delay]);

  useEffect(() => {
    return () => {
      debouncedResults.cancel();
    };
  }, [debouncedResults]);

  return debouncedResults;
};
